import React, { useState, useEffect } from 'react';
import { usersAPI } from '../services/api';

export default function UsersManagement() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    loadUsers();
  }, [filter, page]);

  const loadUsers = async () => {
    setLoading(true);
    try {
      const params = { page, limit: 20 };
      if (filter !== 'all') params.role = filter;
      const { data } = await usersAPI.getAll(params);
      setUsers(data.users);
      setTotal(data.total);
    } catch (error) {
      console.log('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleBlock = async (id) => {
    try {
      await usersAPI.toggleBlock(id);
      loadUsers();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h2>إدارة المستخدمين</h2>
        <div className="filters">
          {['all', 'customer', 'worker'].map((f) => (
            <button
              key={f}
              className={`filter-btn ${filter === f ? 'active' : ''}`}
              onClick={() => { setFilter(f); setPage(1); }}
            >
              {f === 'all' ? 'الكل' : f === 'customer' ? 'العملاء' : 'العمال'}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="loading">جاري التحميل...</div>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>الاسم</th>
                <th>الهاتف</th>
                <th>البريد</th>
                <th>النوع</th>
                <th>الحالة</th>
                <th>تاريخ التسجيل</th>
                <th>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user._id}>
                  <td>{user.name}</td>
                  <td>{user.phone}</td>
                  <td>{user.email || '-'}</td>
                  <td>
                    <span className={`badge ${user.role}`}>
                      {user.role === 'customer' ? 'عميل' : user.role === 'worker' ? 'عامل' : 'مدير'}
                    </span>
                  </td>
                  <td>
                    <span className={`badge ${user.isBlocked ? 'blocked' : 'active'}`}>
                      {user.isBlocked ? 'محظور' : 'نشط'}
                    </span>
                  </td>
                  <td>{new Date(user.createdAt).toLocaleDateString('ar-SA')}</td>
                  <td>
                    {user.role !== 'admin' && (
                      <button
                        className={`btn btn-sm ${user.isBlocked ? 'btn-success' : 'btn-danger'}`}
                        onClick={() => toggleBlock(user._id)}
                      >
                        {user.isBlocked ? 'إلغاء الحظر' : 'حظر'}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pagination">
            <button disabled={page <= 1} onClick={() => setPage(page - 1)}>السابق</button>
            <span>صفحة {page} من {Math.ceil(total / 20)}</span>
            <button disabled={page >= Math.ceil(total / 20)} onClick={() => setPage(page + 1)}>التالي</button>
          </div>
        </>
      )}
    </div>
  );
}
